(function () {
  'use strict';

  angular.module('eclipseApp.core').factory('permissionsService', ['$http', 'uteEndpoint', '$q', '$rootScope', function ($http, uteEndpoint, $q, $rootScope) {
    var service = {};
    service.permissionDetail = {};
    service.permissionDetail.isFidoNonPulseRoam = false;
    service.permissionDetail.isAddTopupBRT = undefined;

    var deferred = $q.defer();

    service.resetPermissionData = function () {    // this fn will be called during log-out to reset permission data
      //CASL - Start
      service.permissionDetail.CASL_CEM_LIMITED = undefined;
      service.permissionDetail.CASL_CEM_ALL = undefined;
      //CASL - End
      //Wcoc
      service.permissionDetail.isFidoNonPulseRoam = false;
      service.permissionDetail.FIDO_UEP = undefined;
      service.permissionDetail.isFidoDisableAllUsage = false;
      service.permissionDetail.isFidoDisplayDataUsage = false;
      //Add Topup
      service.permissionDetail.isAddTopupBRT = undefined;
    }

    service.getPreferences = function () {
      if ($rootScope.ruiMethods.user.is.loggedIn()) {
        $http({
          url: uteEndpoint('v1/permissions'),
          //url:"../resource/permissions.json"
          method: 'POST',
        }).success(function (data) {
          if (_.isEmpty(data)) {
            deferred.reject(data);
            return deferred.promise;
          }
          else {
            _.each(data.permissions, function (value) {
              //CASL - Start
              // if (value.permission && value.permission.toUpperCase() === 'CASL_CEM_LIMITED') {
              //   service.permissionDetail.CASL_CEM_LIMITED = true;
              // }
              // if (value.permission && value.permission.toUpperCase() === 'CASL_CEM_ALL') {
              //   service.permissionDetail.CASL_CEM_ALL = true;
              // }
              //CASL - End
              // WCOC
              // if (value.permission && value.permission.toUpperCase() === 'WCOC_BRT') {
              //   service.permissionDetail.isWcocBRT = true;
              // }
              if (value.permission && value.permission.toUpperCase() === 'FIDO_UEP') {
                service.permissionDetail.FIDO_UEP = true;
              }
              //Fido Roam brt key for Non Pulse plan.
              if (value.permission && value.permission.toUpperCase() === 'FIDO_NONPULSE_ROAM') {
                service.permissionDetail.isFidoNonPulseRoam = true;
              }
              if (value.permission && value.permission.toUpperCase() === 'FIDO_DISABLE_ALL_USAGE') {
                service.permissionDetail.isFidoDisableAllUsage = true;
              }
              if (value.permission && value.permission.toUpperCase() === 'FIDO_DISPLAY_DATA_USAGE') {
                service.permissionDetail.isFidoDisplayDataUsage = true;
              }
              //Add Topup
              if (value.permission && value.permission.toUpperCase() === 'FIDO_ENABLE_ADDON') {
                service.permissionDetail.isAddTopupBRT = true;
              }
            })
          }
          deferred.resolve(data.permissions);
        }).error(function (data) {
          deferred.reject(data);
        });
      }
      return deferred.promise;
    };
    return service;
  }]);
})();
